import script from "./UChoosePersons.vue?vue&type=script&setup=true&lang=ts"
export * from "./UChoosePersons.vue?vue&type=script&setup=true&lang=ts"

import "./UChoosePersons.vue?vue&type=style&index=0&id=0a1e6a26&lang=css"

const __exports__ = script;

export default __exports__